"use strict";
var _BookingImpl_instances, _BookingImpl_data, _BookingImpl_transformMeta;
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const utils_1 = require("../../../../utils");
// Booking Implementation
class BookingImpl {
    constructor(deserialized) {
        _BookingImpl_instances.add(this);
        _BookingImpl_data.set(this, {});
        tslib_1.__classPrivateFieldSet(this, _BookingImpl_data, deserialized.data, "f");
        tslib_1.__classPrivateFieldGet(this, _BookingImpl_instances, "m", _BookingImpl_transformMeta).call(this);
    }
    set insured(value) {
        this.data.insured = value;
    }
    get data() {
        return tslib_1.__classPrivateFieldGet(this, _BookingImpl_data, "f");
    }
}
_BookingImpl_data = new WeakMap(), _BookingImpl_instances = new WeakSet(), _BookingImpl_transformMeta = function _BookingImpl_transformMeta() {
    var _a, _b, _c, _d, _e, _f;
    const dates = (0, utils_1.getStartAndEndTime)((_a = tslib_1.__classPrivateFieldGet(this, _BookingImpl_data, "f")) === null || _a === void 0 ? void 0 : _a.start_at, (_b = tslib_1.__classPrivateFieldGet(this, _BookingImpl_data, "f")) === null || _b === void 0 ? void 0 : _b.end_at);
    if ((_c = tslib_1.__classPrivateFieldGet(this, _BookingImpl_data, "f")) === null || _c === void 0 ? void 0 : _c.meta) {
        tslib_1.__classPrivateFieldGet(this, _BookingImpl_data, "f").meta.dates_number_of_days = dates.days;
        tslib_1.__classPrivateFieldGet(this, _BookingImpl_data, "f").meta.dates_utc_start_at = String(((_d = tslib_1.__classPrivateFieldGet(this, _BookingImpl_data, "f")) === null || _d === void 0 ? void 0 : _d.start_at) || '').replace('Z', '');
        tslib_1.__classPrivateFieldGet(this, _BookingImpl_data, "f").meta.dates_utc_ent_at = String(((_e = tslib_1.__classPrivateFieldGet(this, _BookingImpl_data, "f")) === null || _e === void 0 ? void 0 : _e.end_at) || '').replace('Z', '');
    }
    ;
    (((_f = tslib_1.__classPrivateFieldGet(this, _BookingImpl_data, "f")) === null || _f === void 0 ? void 0 : _f.booking_items) || []).forEach((item) => {
        item.meta.is_suggest_price_cents =
            item.meta.suggested_booking_cost_cents === item.price_cents;
        item.meta.unit_price_cents = item.price_cents / item.quantity;
        return item;
    });
};
exports.default = BookingImpl;
//# sourceMappingURL=Booking.js.map